const ADD_PROJECT = 'ADD_PROJECT'
const DELETE_PROJECT = 'DELETE_PROJECT'
const UPDATE_PROJECT = 'UPDATE_PROJECT'
const ADD_USER_TO_PROJECT = 'ADD_USER_TO_PROJECT'

export { ADD_PROJECT, ADD_USER_TO_PROJECT, DELETE_PROJECT, UPDATE_PROJECT }
